/*****************************************************************************/
/*  File Name: ConsumerLanding.js                                            */
/*  Date:      April 13 2022                                                 */
/*  Author:    Ben Wakutz                                                    */
/*  Purpose:   landingpage based of promos                                   */
/*                                                                           */
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';
//import firebase from 'firebase/app';
import Container from '@mui/material/Container';

import styles from './styles/footer.module.scss';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useROIContext } from '../../context/roiContext';
import * as MODE from '../../constants/modes';

function Footer({ t }) {
  //Load all of the default component varaibles
  const year = new Date();

  const {roi, roiMode} = useROIContext();

  //console.log("systems in footer ->", roi.systems);

  function getBrandString(systems) {
    if (!systems) return "Solta devices";

    // Step 1: filter out upgradeable systems
    const nonUpgradeableSystems = Object.values(systems).filter(
      (sys) => !sys.upgradeable
    );

    // Step 2: extract unique brand names
    const brandNames = [...new Set(nonUpgradeableSystems.map((sys) => sys.brandName))];

    // Step 3: build readable string
    if (brandNames.length === 0) return "Solta devices";
    if (brandNames.length === 1) return brandNames[0];
    if (brandNames.length === 2) return `${brandNames[0]} and ${brandNames[1]}`;

    return (
      brandNames.slice(0, -1).join(", ") + " and " + brandNames.slice(-1)
    );
  }
  const brandString = getBrandString(roi.systems);

  return (
    <div className={styles.footerContainer}>
      <Grid container item xs={12} className={styles.footerGrid} justifyContent={'center'} spacing={1}>
        {roiMode === MODE.capital ? (
          <>
            <Grid item xs={12}>
              <Typography variant='body2' className={styles.finePrint} textAlign={'left'}>
                This is not a contractual document. This document is for information purpose only and does not constitute an offer or create any contractual relationship. We make every reasonable effort to ensure the accuracy and validity of the information provided. However, as policies, price points, dates, conditions, and information are continually changing, we reserve the right to make changes at any time and accept no liability or responsibility for any errors or omissions.
              </Typography>
            </Grid>
            <Grid item xs={12} md={7}>
              <Typography variant='body2' className={styles.finePrint} textAlign={'left'}>
                Solta Medical is a global leader in the aesthetic industry providing innovative products such as Thermage® FLX radiofrequency systems and the Clear + Brilliant®, Clear + Brilliant Touch® and Fraxel® lasers.
              </Typography>
            </Grid>
            <Grid item xs={12} md={5}>
              <Typography variant='body2' className={styles.finePrint} textAlign={'left'}>
                ®/TM are trademarks of Bausch Health Companies Inc. or its affiliates.<br />©2026 Bausch Health Companies Inc. SLT.0142.USA.23V3.0
              </Typography>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12}>
              <Typography variant='body2' className={styles.finePrintBigger} textAlign={'left'}>
                The information provided is hypothetical and for illustrative purposes only.
                It does not constitute a guarantee of profit, revenue, or practice growth and is not financial, legal, or medical advice.
                All potential revenue/profit information are estimates based on the examples provided.
                Actual use cases may vary and may be subject to inconsistencies based on various factors.
                Additional costs may apply.
                Decisions to purchase and use {brandString} should be based on the provider’s independent clinical judgement and medical needs of patients, not financial considerations.
                Providers should conduct their own independent analysis based on their practice and patient needs and comply with all applicable laws.
                Visit Solta.com for product details and Important Safety Information.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant='body2' className={styles.finePrint} textAlign={'left'}>
                ®/TM are trademarks of Solta Medical Inc. or its affiliates. ©{year.getFullYear()} Solta Medical Inc. SLT.0142.USA.23V2.0
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
}

export default withTranslation()(Footer);
